import React, { useEffect, useRef, useState } from "react";
import bulbImage from "../../../images/buld.png";
import "react-datepicker/dist/react-datepicker.css";
import Footer from "../../../core/common/footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../core/data/redux/store";
import z from "zod";
import useApi from "../../../core/customhook/useApi";

import Swal from "sweetalert2";
import SnipperLoader from "../../../core/common/loader/SnipperLoader";
import { allCountries, apibaseurl } from "../../../environment";
import { triggerPackageReload } from "../../../core/data/redux/packageSlice";
import { all_routes } from "../../router/all_routes";
import { useLocation, useNavigate } from "react-router";
import { useAuth } from "../../auth/AuthContext";
import { disabledStatuses, getTodayDate } from "../../../core/common/DateValidHelper";

const EmployementForm1 = () => {
  const templates = useSelector((state: RootState) => state.package.templates);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { authData } = useAuth();

  const {
    assignment_template_id,
    assignment_id,
    case_id,
    candidate_id,
    actor_type,
  } = state || {};

  const aadharTemplate = templates.find(
    (item: any) => item.check_name === "Employment",
  );

  const assignmentTemplateId = aadharTemplate?.assignment_template_id;
  const caseId = aadharTemplate?.case_id;
  const assignmentId = aadharTemplate?.assignment_id;
  const candidateId = authData?.candidate?.candidateId;
  const templateStatus = aadharTemplate?.status;

  const [formFields, setFormFields] = useState<any[]>([]);
  const [formData, setFormData] = useState<any>({});
  const [noDocument, setNoDocument] = useState<Record<string, boolean>>({});
  const [isFresher, setIsFresher] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const fileInputRefs = useRef<Record<string, HTMLInputElement | null>>({});
  // yyyy-mm-dd format check (N/A ya empty ko ignore karta hai)
  const isValidDate = (v: any): v is string =>
    typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v);

  const isSunday = (v: any) => {
    if (!isValidDate(v)) return false;
    const [y, m, d] = v.split("-").map(Number);
    return new Date(y, m - 1, d).getDay() === 0;
  };

  const PF_REGEX = /^[A-Z]{2}[\s/]?[A-Z]{3}[\s/]?\d{7}[\s/]?\d{3}[\s/]?\d{7}$/;
  const UAN_REGEX = /^\d{12}$/;

  // Error message return karta hai, valid ho to "" (empty / N/A ko ignore karta hai)
  const getStatutoryError = (fieldId: string, value: any) => {
    const v = String(value ?? "").trim();
    if (!v || v.toUpperCase() === "N/A") return "";

    if (
      fieldId === "pf_verification_number" &&
      !PF_REGEX.test(v.toUpperCase())
    ) {
      return "Enter a valid PF number (e.g. MH/BAN/0000000/000/0000000)";
    }

    if (fieldId === "uan_number" && !UAN_REGEX.test(v)) {
      return "UAN must be exactly 12 digits";
    }

    return "";
  };
  // =========m Validation ==========

  // ======= Modal State =============

  const [showReplyModal, setShowReplyModal] = useState(false);
  const [replyRemarks, setReplyRemarks] = useState("");
  const [replyDocuments, setReplyDocuments] = useState<File[]>([]);

  // ======== Modal stat eend her e===============

  const SECTION_CONFIG = [
    {
      title: "Organization Details",
      icon: "ti ti-building",
      fields: [
        "company_name",
        "deployed_company",
        "employment_type",
        "organization_address_line_1",
        "organization_address_line_2",
        "pincode",
        "organization_country",
        "organization_state",
        "organization_city",
      ],
    },
    {
      title: "Employment Details",
      icon: "ti ti-briefcase",
      fields: [
        "employee_code_id",
        "last_position_held",
        "date_of_joining",
        "date_of_relieving",
        "currency",
        "salary_package",
      ],
    },
    {
      title: "Supervisor / Manager Details",
      icon: "ti ti-user",
      fields: [
        "supervisor_details_available",
        "reporting_manager_name",
        "reporting_manager_email",
        "reporting_manager_mobile",
        "reporting_manager_designation",
      ],
    },
    {
      title: "HR Details",
      icon: "ti ti-id-badge-2",
      fields: [
        "hr_details_available",
        "hr_name",
        "hr_contact_details",
        "hr_email_id",
      ],
    },
    {
      title: "Statutory Details",
      icon: "ti ti-file-text",
      fields: ["pf_verification_number", "uan_number"],
    },
  ];

  // Group formFields into sections

  // Maps each field_id to an icon + color theme for the read-only card view

  const FIELD_ICON_MAP: Record<
    string,
    { icon: string; bg: string; color: string }
  > = {
    company_name: { icon: "ti ti-building", bg: "#e8ecfb", color: "#4c5fd5" },
    deployed_company: {
      icon: "ti ti-building-skyscraper",
      bg: "#e8ecfb",
      color: "#4c5fd5",
    },
    employment_type: {
      icon: "ti ti-briefcase",
      bg: "#f2e8fb",
      color: "#9b51e0",
    },
    organization_address_line_1: {
      icon: "ti ti-map-pin",
      bg: "#e6f0ff",
      color: "#2f6feb",
    },
    organization_address_line_2: {
      icon: "ti ti-map-pin",
      bg: "#e6f0ff",
      color: "#2f6feb",
    },
    pincode: { icon: "ti ti-map-pin-code", bg: "#e6f0ff", color: "#2f6feb" },
    organization_country: {
      icon: "ti ti-world",
      bg: "#e6f0ff",
      color: "#2f6feb",
    },
    organization_state: { icon: "ti ti-map", bg: "#e6f0ff", color: "#2f6feb" },
    organization_city: {
      icon: "ti ti-map-pin",
      bg: "#e6f0ff",
      color: "#2f6feb",
    },
    employee_code_id: {
      icon: "ti ti-id-badge-2",
      bg: "#fdeee0",
      color: "#e08b2f",
    },
    last_position_held: {
      icon: "ti ti-file-text",
      bg: "#f2e8fb",
      color: "#9b51e0",
    },
    date_of_joining: {
      icon: "ti ti-calendar-event",
      bg: "#fdeee0",
      color: "#e08b2f",
    },
    date_of_relieving: {
      icon: "ti ti-calendar-minus",
      bg: "#fdeee0",
      color: "#e08b2f",
    },
    currency: { icon: "ti ti-currency-rupee", bg: "#e3f6ec", color: "#2fa96b" },
    salary_package: { icon: "ti ti-cash", bg: "#e3f6ec", color: "#2fa96b" },
    supervisor_details_available: {
      icon: "ti ti-user-check",
      bg: "#f2e8fb",
      color: "#9b51e0",
    },
    reporting_manager_name: {
      icon: "ti ti-user",
      bg: "#f2e8fb",
      color: "#9b51e0",
    },
    reporting_manager_email: {
      icon: "ti ti-mail",
      bg: "#e6f0ff",
      color: "#2f6feb",
    },
    reporting_manager_mobile: {
      icon: "ti ti-phone",
      bg: "#e3f6ec",
      color: "#2fa96b",
    },
    reporting_manager_designation: {
      icon: "ti ti-award",
      bg: "#fdeee0",
      color: "#e08b2f",
    },
    hr_details_available: {
      icon: "ti ti-id-badge-2",
      bg: "#f2e8fb",
      color: "#9b51e0",
    },
    hr_name: { icon: "ti ti-user", bg: "#f2e8fb", color: "#9b51e0" },
    hr_contact_details: {
      icon: "ti ti-phone",
      bg: "#e3f6ec",
      color: "#2fa96b",
    },
    hr_email_id: { icon: "ti ti-mail", bg: "#e6f0ff", color: "#2f6feb" },
    pf_verification_number: {
      icon: "ti ti-file-invoice",
      bg: "#e6f0ff",
      color: "#2f6feb",
    },
    uan_number: { icon: "ti ti-file-invoice", bg: "#fdeee0", color: "#e08b2f" },
  };

  // Fallback for any field not in the map above
  const DEFAULT_ICON_THEME = {
    icon: "ti ti-info-circle",
    bg: "#eef0f5",
    color: "#6b7280",
  };

  const renderField = (field: any) => {
    const isDisabled =
      isFresher || disabledStatuses.includes(templateStatus ?? "");

    // Resolve the display value (for dropdowns, show the label not the raw value)
    const getDisplayValue = () => {
      if (isFresher) return "N/A";

      const rawValue = formData[field.field_id];

      if (!rawValue) return "-";

      if (field.type === "dropdown") {
        const matchedOption = field.options?.find(
          (opt: any) => opt.value === rawValue,
        );
        return matchedOption ? matchedOption.label : rawValue;
      }

      if (field.type === "date" && rawValue) {
        // Optional: format date nicely (DD MMM YYYY)
        const dateObj = new Date(rawValue);
        if (!isNaN(dateObj.getTime())) {
          return dateObj.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          });
        }
      }

      return rawValue;
    };

    // ===== READ-ONLY CARD VIEW =====
    // ===== READ-ONLY CARD VIEW =====
    if (isDisabled) {
      const theme = FIELD_ICON_MAP[field.field_id] || DEFAULT_ICON_THEME;

      return (
        <div key={field.field_uuid} className="col-md-6 mb-3">
          <div
            className="d-flex align-items-start gap-3 pb-3"
            style={{ borderBottom: "1px solid #f0f1f5" }}
          >
            <div
              className="d-flex align-items-center justify-content-center flex-shrink-0"
              style={{
                width: "42px",
                height: "42px",
                borderRadius: "12px",
                background: theme.bg,
              }}
            >
              <i
                className={theme.icon}
                style={{ fontSize: "20px", color: theme.color }}
              ></i>
            </div>

            <div className="flex-grow-1">
              <div
                className="text-muted mb-1"
                style={{ fontSize: "12.5px", fontWeight: 500 }}
              >
                {field.label}
              </div>
              <div className="fw-bold text-dark" style={{ fontSize: "14.5px" }}>
                {getDisplayValue()}
              </div>
            </div>
          </div>
        </div>
      );
    }

    // ===== NORMAL EDITABLE VIEW (unchanged) =====
    return (
      <div key={field.field_uuid} className="col-md-6 mb-3 d-flex flex-column">
        <label className="form-label fw-medium">
          {field.label}
          {field.required && <span className="text-danger ms-1">*</span>}
        </label>

        {field.type === "dropdown" ? (
          <select
            className={`form-select ${errors[field.field_id] ? "is-invalid" : ""}`}
            value={formData[field.field_id] || ""}
            required={field.required}
            onChange={(e) => handleFieldChange(field.field_id, e.target.value)}
          >
            <option value="">{field.placeholder || "Select"}</option>
            {field.options?.map((option: any) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        ) : (
          <input
            type={field.type}
            className={`form-control ${errors[field.field_id] ? "is-invalid" : ""}`}
            placeholder={field.placeholder}
            value={formData[field.field_id] ?? ""}
            required={field.required}
            // onChange={(e) => {
            //   handleFieldChange(field.field_id, e.target.value);
            //   setErrors((prev) => ({ ...prev, [field.field_id]: "" }));
            // }}
            onChange={(e) => {
              handleFieldChange(field.field_id, e.target.value);
            }}
            min={
              field.field_id === "date_of_relieving" &&
              isValidDate(formData.date_of_joining)
                ? formData.date_of_joining
                : undefined
            }
            max={
              field.field_id === "date_of_joining"
                ? isValidDate(formData.date_of_relieving)
                  ? formData.date_of_relieving < getTodayDate()
                    ? formData.date_of_relieving
                    : getTodayDate()
                  : getTodayDate()
                : field.field_id === "date_of_relieving"
                  ? getYesterdayDate()
                  : undefined
            }
            pattern={field?.validation_rules?.pattern}
            maxLength={field?.validation_rules?.maxLength}
            minLength={field?.validation_rules?.minLength}
            onBlur={(e) => {
              const msg = getStatutoryError(field.field_id, e.target.value);
              if (msg)
                setErrors((prev) => ({ ...prev, [field.field_id]: msg }));
            }}
            inputMode={field.field_id === "uan_number" ? "numeric" : undefined}
          />
        )}

        {errors[field.field_id] && (
          <div className="invalid-feedback d-block">
            {errors[field.field_id]}
          </div>
        )}
        {field.field_id === "date_of_joining" &&
          isSunday(formData.date_of_joining) && (
            <div
              className="small mt-1 d-flex align-items-center gap-1"
              style={{ color: "#B45309" }}
            >
              <i className="ti ti-alert-triangle"></i>
              You have selected a Sunday as the Date of Joining. Please confirm
              this date is correct.
            </div>
          )}
      </div>
    );
  };

  const nonFileFields = formFields.filter((f) => f.type !== "file");
  const usedFieldIds = new Set<string>();

  const sectionsWithData = SECTION_CONFIG.map((section) => {
    const sectionFields = nonFileFields
      .filter((f) => section.fields.includes(f.field_id))
      .sort((a, b) => a.display_order - b.display_order);
    sectionFields.forEach((f) => usedFieldIds.add(f.field_id));
    return { ...section, sectionFields };
  }).filter((section) => section.sectionFields.length > 0);

  const leftoverFields = nonFileFields
    .filter((f) => !usedFieldIds.has(f.field_id))
    .sort((a, b) => a.display_order - b.display_order);

  if (leftoverFields.length > 0) {
    sectionsWithData.push({
      title: "Other Details",
      icon: "ti ti-list-details",
      fields: [],
      sectionFields: leftoverFields,
    });
  }

  const generateSchema = (
    fields: any[],
    noDocument: Record<string, boolean>,
  ) => {
    const schemaFields: Record<string, any> = {};

    fields.forEach((field) => {
      let validator: any = z.any();

      if (field.type !== "file") {
        validator = z.string();

        if (field.required) {
          validator = validator.min(1, `${field.label} is required`);
        }

        if (field?.required && field.validation_rules?.minLength) {
          validator = validator.min(
            field.validation_rules.minLength,
            `${field.label} must be at least ${field.validation_rules.minLength} characters`,
          );
        }

        if (field?.required && field.validation_rules?.maxLength) {
          validator = validator.max(
            field.validation_rules.maxLength,
            `${field.label} cannot exceed ${field.validation_rules.maxLength} characters`,
          );
        }

        if (field?.required && field.validation_rules?.pattern) {
          validator = validator.regex(
            new RegExp(field.validation_rules.pattern),
            `${field.label} is invalid`,
          );
        }
      }

      if (field.type === "file") {
        const skipValidation = noDocument?.[field.field_id] === true;

        const isMultiple = field.file_config?.multiple === true;

        // Check already uploaded documents returned by API
        const hasExistingFiles =
          Array.isArray(field.uploaded_files) &&
          field.uploaded_files.some((file: any) => Boolean(file?.url));

        if (skipValidation || hasExistingFiles) {
          // Existing documents satisfy required validation
          validator = z.any().optional().nullable();
        } else if (isMultiple) {
          // Multiple file upload validation
          validator = field.required
            ? z.array(z.instanceof(File)).min(1, `${field.label} is required`)
            : z.array(z.instanceof(File)).optional().nullable();
        } else {
          // Single file upload validation
          validator = field.required
            ? z.instanceof(File, {
                message: `${field.label} is required`,
              })
            : z.any().optional().nullable();
        }
      }

      schemaFields[field.field_id] = validator;
    });

    return z.object(schemaFields).superRefine((data: any, ctx) => {
      const joining = data.date_of_joining;
      const relieving = data.date_of_relieving;

      // Joining Date cannot be in the future
      if (isValidDate(joining) && joining > getTodayDate()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["date_of_joining"],
          message: "Date of Joining cannot be a future date",
        });
      }

      // Date of Relieving cannot be before Date of Joining
      if (
        isValidDate(joining) &&
        isValidDate(relieving) &&
        relieving < joining
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["date_of_relieving"],
          message: "Date of Relieving cannot be before Date of Joining",
        });
      }

      // Relieving date must be before today
      if (isValidDate(relieving)) {
        const now = new Date();

        const today =
          `${now.getFullYear()}-` +
          `${String(now.getMonth() + 1).padStart(2, "0")}-` +
          `${String(now.getDate()).padStart(2, "0")}`;

        if (relieving >= today) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["date_of_relieving"],
            message: "Date of Relieving must be before today",
          });
        }
      }

      // PF & UAN format validation
      ["pf_verification_number", "uan_number"].forEach((id) => {
        const msg = getStatutoryError(id, data[id]);

        if (msg) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: [id],
            message: msg,
          });
        }
      });
    });
  };

  const formFieldsAPI = useApi<any>(
    `/api/v1/candidate/templates/${assignmentTemplateId}`,
    {
      method: "GET",
      autoCall: false,
      handleGlobalError: false,
    },
  );

  const templateSaveAPI = useApi<any>(
    `/api/v1/candidate/templates/${assignmentTemplateId}/save`,
    {
      method: "POST",
      autoCall: false,
      handleGlobalError: false,
    },
  );

  const templateUpdateAPI = useApi<any>(
    `/api/v1/candidate/forms/filled/${assignmentTemplateId}`,
    {
      method: "PUT",
      autoCall: false,
      handleGlobalError: false,
    },
  );

  const insuffResponse = useApi<any>(
    `/api/v1/insufficiency/candidate-response`,
    {
      method: "POST",
      autoCall: false,
      handleGlobalError: false,
    },
  );

  const employementForm = async () => {
    try {
      const response = await formFieldsAPI.callApi();
      if (response?.success) {
        const fields = response?.data?.fields || [];
        setFormFields(fields);

        const initialValues: any = {};

        fields.forEach((field: any) => {
          initialValues[field.field_id] =
            field.type === "file" ? null : field.value || "";
        });

        setFormData(initialValues);
      }
    } catch (error) {
      console.error("Error fetching form fields:", error);
    }
  };

  const formLoading = formFieldsAPI.loading;

  useEffect(() => {
    if (assignmentTemplateId) {
      employementForm();
    }
  }, [assignmentTemplateId]);

  const handleFieldChange = async (fieldId: string, value: any) => {
    // UAN: sirf digits, max 12
    if (fieldId === "uan_number" && value !== "N/A") {
      value = String(value ?? "")
        .replace(/\D/g, "")
        .slice(0, 12);
    }

    // PF number: uppercase, sirf letters/digits/slash/space, max 26
    if (fieldId === "pf_verification_number" && value !== "N/A") {
      value = String(value ?? "")
        .toUpperCase()
        .replace(/[^A-Z0-9/\s]/g, "")
        .slice(0, 26);
    }
    // Date of Relieving, Date of Joining se pehle ki nahi ho sakti (kisi bhi order me)
    if (fieldId === "date_of_joining" || fieldId === "date_of_relieving") {
      const joining =
        fieldId === "date_of_joining" ? value : formData.date_of_joining;

      const relieving =
        fieldId === "date_of_relieving" ? value : formData.date_of_relieving;

      // 1. Joining Date cannot be in the future
      if (
        fieldId === "date_of_joining" &&
        isValidDate(value) &&
        value > getTodayDate()
      ) {
        setFormData((prev: any) => ({
          ...prev,
          [fieldId]: "",
        }));

        setErrors((prev) => ({
          ...prev,
          [fieldId]: "Date of Joining cannot be a future date",
        }));

        return;
      }

      // 2. Relieving Date must be before today
      if (
        fieldId === "date_of_relieving" &&
        isValidDate(value) &&
        value >= getTodayDate()
      ) {
        setFormData((prev: any) => ({
          ...prev,
          [fieldId]: "",
        }));

        setErrors((prev) => ({
          ...prev,
          [fieldId]: "Date of Relieving must be before today",
        }));

        return;
      }

      // 3. Keep existing Joining vs Relieving validation
      if (
        isValidDate(joining) &&
        isValidDate(relieving) &&
        relieving < joining
      ) {
        setFormData((prev: any) => ({
          ...prev,
          [fieldId]: "",
        }));

        setErrors((prev) => ({
          ...prev,
          [fieldId]:
            fieldId === "date_of_relieving"
              ? "Date of Relieving cannot be before Date of Joining"
              : "Date of Joining cannot be after Date of Relieving",
        }));

        return;
      }
    }

    setFormData((prev: any) => {
      const updatedData = {
        ...prev,
        [fieldId]: value,
      };

      // Supervisor Details
      if (fieldId === "supervisor_details_available") {
        if (value === "NO") {
          updatedData.reporting_manager_name = "N/A";
          updatedData.reporting_manager_email = "N/A";
          updatedData.reporting_manager_mobile = "N/A";
          updatedData.reporting_manager_designation = "N/A";
        } else {
          updatedData.reporting_manager_name = "";
          updatedData.reporting_manager_email = "";
          updatedData.reporting_manager_mobile = "";
          updatedData.reporting_manager_designation = "";
        }
      }

      // HR Details
      if (fieldId === "hr_details_available") {
        if (value === "NO") {
          updatedData.hr_name = "N/A";
          updatedData.hr_contact_details = "N/A";
          updatedData.hr_email_id = "N/A";
        } else {
          updatedData.hr_name = "";
          updatedData.hr_contact_details = "";
          updatedData.hr_email_id = "";
        }
      }

      // If pincode is changed before 6 digits,
      // clear state and city
      if (fieldId === "pincode" && value.length < 6) {
        updatedData.organization_state = "";
        updatedData.organization_city = "";
      }

      return updatedData;
    });

    // Clear current field error
    setErrors((prev: any) => ({
      ...prev,
      [fieldId]: "",
    }));

    // Pincode lookup
    if (fieldId === "pincode" && /^[0-9]{6}$/.test(value)) {
      await getLocationByPincode(value);
    }
  };
  const handleNoDocumentChange = (fieldId: string, checked: boolean) => {
    setNoDocument((prev) => ({
      ...prev,
      [fieldId]: checked,
    }));

    if (checked) {
      handleFieldChange(fieldId, null);

      // Clear the file input so filename disappears
      if (fileInputRefs.current[fieldId]) {
        fileInputRefs.current[fieldId]!.value = "";
      }
    }
  };

  const buildFormDataPayload = () => {
    const payload = new FormData();

    // Start with all normal form values.
    const jsonData: any = {
      ...formData,
    };

    Object.keys(formData).forEach((key) => {
      const value = formData[key];

      // ==========================================
      // SINGLE FILE
      // ==========================================
      if (value instanceof File) {
        payload.append(key, value);

        // File must NOT remain inside JSON formData
        delete jsonData[key];
        return;
      }

      // ==========================================
      // MULTIPLE FILES
      // ==========================================
      if (Array.isArray(value)) {
        const files = value.filter(
          (item): item is File => item instanceof File,
        );

        if (files.length > 0) {
          files.forEach((file) => {
            payload.append(key, file);
          });

          // File[] must NOT remain inside JSON formData
          delete jsonData[key];
        }
      }
    });

    payload.append("formData", JSON.stringify(jsonData));

    return payload;
  };

  const handleSaveDocument = async () => {
    try {
      if (!isFresher) {
        const schema = generateSchema(formFields, noDocument);

        const validationResult = schema.safeParse(formData);

        if (!validationResult.success) {
          const fieldErrors: Record<string, string> = {};

          validationResult.error.issues.forEach((issue) => {
            const fieldName = issue.path[0] as string;

            if (!fieldErrors[fieldName]) {
              fieldErrors[fieldName] = issue.message;
            }
          });

          Swal.fire({
            icon: "warning",
            title: "Warning",
            text: "Please complete all required fields.",
          });

          setErrors(fieldErrors);
          return;
        }

        setErrors({});
      }

      // Same payload builder works for fresher/non-fresher
      const payload = buildFormDataPayload();

      // Debug
      // payload.forEach((value, key) => {
      //   console.log(key, value instanceof File ? `FILE: ${value.name}` : value);
      // });

      // return

      const response = await templateSaveAPI.callApi(payload);

      if (response?.success) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "Document saved successfully",
          confirmButtonText: "OK",
        });

        dispatch(triggerPackageReload());

        // Reload fields so uploaded_files returned by backend are shown
        await employementForm();
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Save Failed",
        text:
          error?.response?.data?.error ||
          error?.message ||
          "Something went wrong",
      });
    }
  };

  const handleUpdateDocument = async () => {
    try {
      if (!isFresher) {
        const schema = generateSchema(formFields, noDocument);

        const validationResult = schema.safeParse(formData);

        if (!validationResult.success) {
          const fieldErrors: Record<string, string> = {};

          validationResult.error.issues.forEach((issue) => {
            const fieldName = issue.path[0] as string;

            if (!fieldErrors[fieldName]) {
              fieldErrors[fieldName] = issue.message;
            }
          });

          Swal.fire({
            icon: "warning",
            title: "Warning",
            text: "Please complete all required fields.",
          });

          setErrors(fieldErrors);
          return;
        }

        setErrors({});
      }

      const payload = buildFormDataPayload();

      payload.forEach((value, key) => {
        console.log(key, value instanceof File ? `FILE: ${value.name}` : value);
      });

      const response = await templateUpdateAPI.callApi(payload);

      if (response?.success) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "Document updated successfully",
          confirmButtonText: "OK",
        });

        dispatch(triggerPackageReload());

        // Get latest uploaded_files from server
        await employementForm();
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text:
          error?.response?.data?.error ||
          error?.message ||
          "Something went wrong",
      });
    }
  };

  const handleReplyFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;

    setReplyDocuments(Array.from(e.target.files));
  };

  const removeReplyFile = (index: number) => {
    setReplyDocuments((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmitReply = async () => {
    if (!replyRemarks.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Remarks Required",
        text: "Please enter your remarks before submitting.",
      });
      return;
    }

    try {
      const payload = new FormData();

      payload.append(
        "assignment_template_id",
        assignment_template_id ?? assignmentTemplateId ?? "",
      );

      payload.append("assignment_id", assignment_id ?? assignmentId ?? "");

      payload.append("case_id", case_id ?? caseId ?? "");

      payload.append("candidate_id", candidate_id ?? candidateId ?? "");

      payload.append("actor_due_on", actor_type ?? "CANDIDATE");
      payload.append("remarks", replyRemarks);

      // Multiple documents
      replyDocuments.forEach((file) => {
        payload.append("documents", file);
      });

      const res = await insuffResponse.callApi(payload);

      if (res?.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Your response has been submitted successfully.",
        });

        // Reset form
        // setReplyRemarks("");
        // setReplyDocuments([]);
        // setShowReplyModal(false);
        navigate(all_routes.caseSummary);
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: error?.message || "Unable to submit your response.",
      });
    }
  };

  const getLocationByPincode = async (pincode: string) => {
    try {
      const response = await fetch(
        `https://api.postalpincode.in/pincode/${pincode}`,
      );

      const data = await response.json();

      if (
        data?.[0]?.Status === "Success" &&
        data?.[0]?.PostOffice?.length > 0
      ) {
        const postOffice = data[0].PostOffice[0];

        setFormData((prev: any) => ({
          ...prev,

          // Fill country
          organization_country: postOffice.Country || "India",

          // Fill state
          organization_state: postOffice.State || "",

          // Fill city
          organization_city:
            postOffice.District ||
            postOffice.Division ||
            postOffice.Block ||
            "",
        }));

        setErrors((prev: any) => ({
          ...prev,
          pincode: "",
          organization_country: "",
          organization_state: "",
          organization_city: "",
        }));
      } else {
        setFormData((prev: any) => ({
          ...prev,
          organization_country: "",
          organization_state: "",
          organization_city: "",
        }));
      }
    } catch (error) {
      console.error("Pincode API error:", error);
    }
  };

  const handleFresherChange = (checked: boolean) => {
    setIsFresher(checked);

    if (checked) {
      setFormData((prev: any) => {
        const updated = { ...prev };

        formFields?.forEach((field: any) => {
          if (field.field_id) {
            updated[field.field_id] = "N/A";
          }
        });

        return updated;
      });

      setErrors({});
    } else {
      // Optional: clear fields when user unchecks fresher
      setFormData((prev: any) => {
        const updated = { ...prev };

        formFields?.forEach((field: any) => {
          if (field.field_id && updated[field.field_id] === "N/A") {
            updated[field.field_id] = "";
          }
        });

        return updated;
      });
    }
  };

  useEffect(() => {
    const fieldsToCheck = (formFields || []).filter(
      (f: any) => f.field_id && f.type !== "file",
    );
    if (fieldsToCheck.length === 0) return;

    const allNA = fieldsToCheck.every(
      (f: any) =>
        String(formData?.[f.field_id] ?? "")
          .trim()
          .toUpperCase() === "N/A",
    );

    setIsFresher(allNA);
  }, [formData, formFields]);



  const getYesterdayDate = () => {
    const date = new Date();
    date.setDate(date.getDate() - 1);

    return date.toLocaleDateString("en-CA"); // YYYY-MM-DD
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-8">
              {formLoading ? (
                <SnipperLoader />
              ) : (
                <div className="card overflow-hidden">
                  {/* Header */}
                  <div className="border-bottom px-4 py-3">
                    <h5 className="fw-semibold mb-0">Employment</h5>
                  </div>

                  <div className="p-4">
                    {/* Employment Details */}
                    <div
                      className="border rounded-3 p-3 mb-4"
                      style={{
                        background: "#f8f9fa",
                        borderColor: "#dee2e6",
                      }}
                    >
                      <div className="form-check d-flex align-items-start m-0">
                        <input
                          id="fresher"
                          className="form-check-input mt-1"
                          type="checkbox"
                          checked={isFresher}
                          onChange={(e) =>
                            handleFresherChange(e.target.checked)
                          }
                          style={{
                            width: "20px",
                            height: "20px",
                            cursor: "pointer",
                          }}
                        />

                        <label
                          htmlFor="fresher"
                          className="form-check-label ms-3 w-100"
                          style={{ cursor: "pointer" }}
                        >
                          <div className="d-flex align-items-center gap-2 mb-1">
                            <span className="fw-semibold text-dark">
                              I am a Fresher
                            </span>
                            <i className="ti ti-briefcase-off text-primary fs-3"></i>
                          </div>

                          <small className="text-muted">
                            Select this option if you do not have any prior work
                            experience. Employment-related fields will be
                            automatically marked as <strong>N/A</strong>.
                          </small>
                        </label>
                      </div>
                    </div>
                    {/* Top Form */}
                    <div className="row">
                      {sectionsWithData.map((section) => (
                        <div
                          className="card shadow-sm mb-4 border-0"
                          key={section.title}
                          style={{ boxShadow: "0 1px 6px rgba(0,0,0,0.06)" }}
                        >
                          <div className="card-header bg-white border-0 d-flex align-items-center gap-2 py-3">
                            <i
                              className={`${section.icon} text-primary fs-3`}
                            ></i>
                            <h6
                              className="mb-0 fw-semibold"
                              style={{
                                letterSpacing: "0.02em",
                                color: "#344054",
                              }}
                            >
                              {section.title}
                            </h6>
                          </div>
                          <div className="card-body pt-0">
                            <div className="row">
                              {section.sectionFields.map(renderField)}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Documents Section */}
                    <div className="border-top pt-4 mt-3">
                      <h5 className="fw-bold mb-3">Employment Documents</h5>

                      <div className="mb-3">
                        <label className="form-label fw-medium">
                          Instructions:
                        </label>

                        <ol className="small ps-3 mb-0">
                          <li>
                            Kindly ensure the photocopy/picture is readable and
                            not pixelated/blurred.
                          </li>

                          <li>
                            Documents Accepted: Pdf, Jpeg, Jpg, Png, doc, docx
                            are allowed
                          </li>

                          <li>Ensure document is not more than 5MB in size.</li>
                        </ol>
                      </div>

                      {formFields
                        .filter((field) => field.type === "file")
                        .sort((a, b) => a.display_order - b.display_order)
                        .map((field) => (
                          <div
                            key={field.field_uuid}
                            className="row align-items-center mb-5"
                          >
                            <div className="col-lg-6">
                              <label className="form-label fw-semibold">
                                {field.label}
                                {field.required && (
                                  <span className="text-danger ms-1">*</span>
                                )}

                                {field.file_config?.multiple && (
                                  <span className="text-muted ms-2 fw-normal">
                                    (Select multiple documents)
                                  </span>
                                )}
                              </label>

                              <input
                                ref={(el) => {
                                  fileInputRefs.current[field.field_id] = el;
                                }}
                                type="file"
                                className="form-control"
                                multiple={field.file_config?.multiple}
                                accept={field.file_config?.allowedExtensions
                                  ?.map((type: string) => `.${type}`)
                                  .join(",")}
                                onChange={(e) => {
                                  if (field.file_config?.multiple) {
                                    handleFieldChange(
                                      field.field_id,
                                      Array.from(e.target.files || []),
                                    );
                                  } else {
                                    handleFieldChange(
                                      field.field_id,
                                      e.target.files?.[0] || null,
                                    );
                                  }
                                }}
                                disabled={
                                  noDocument[field.field_id] ||
                                  disabledStatuses.includes(
                                    templateStatus ?? "",
                                  )
                                }
                                required={
                                  Boolean(field.required) &&
                                  !noDocument?.[field.field_id] &&
                                  !field.uploaded_files?.some((file: any) =>
                                    Boolean(file?.url),
                                  )
                                }
                              />
                              <div className="form-check mt-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={noDocument[field.field_id] || false}
                                  onChange={(e) =>
                                    handleNoDocumentChange(
                                      field.field_id,
                                      e.target.checked,
                                    )
                                  }
                                />

                                <label className="form-check-label text-muted small">
                                  I do not have the document
                                </label>
                              </div>
                            </div>

                            <div className="col-lg-6 text-center mt-4 mt-lg-0">
                              {field.uploaded_files?.length > 0 ? (
                                <div className="text-center">
                                  {/* If user selected NEW files, show new files */}
                                  {Array.isArray(formData[field.field_id]) &&
                                  formData[field.field_id].length > 0 ? (
                                    <>
                                      <i
                                        className="bi bi-file-earmark-pdf-fill text-danger"
                                        style={{
                                          fontSize: "50px",
                                          cursor: "pointer",
                                        }}
                                      />

                                      {formData[field.field_id].map(
                                        (file: File, index: number) => (
                                          <p
                                            key={index}
                                            className="text-danger small mb-0"
                                            style={{
                                              cursor: "pointer",
                                              wordBreak: "break-word",
                                            }}
                                          >
                                            {file.name}
                                          </p>
                                        ),
                                      )}
                                    </>
                                  ) : formData[field.field_id] instanceof
                                    File ? (
                                    <>
                                      {/* Single newly selected file */}
                                      <i
                                        className="bi bi-file-earmark-pdf-fill text-danger"
                                        style={{
                                          fontSize: "50px",
                                          cursor: "pointer",
                                        }}
                                      />

                                      <p
                                        className="text-danger small mb-0"
                                        style={{
                                          cursor: "pointer",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {formData[field.field_id].name}
                                      </p>
                                    </>
                                  ) : (
                                    <>
                                      {/* Existing uploaded files */}
                                      <i
                                        className="bi bi-file-earmark-pdf-fill text-danger"
                                        style={{
                                          fontSize: "50px",
                                        }}
                                      />

                                      {field.uploaded_files.map(
                                        (file: any, index: number) => (
                                          <a
                                            key={index}
                                            href={`${apibaseurl}${file.url}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-decoration-none d-block"
                                          >
                                            <p
                                              className="text-danger small mb-0"
                                              style={{
                                                cursor: "pointer",
                                                wordBreak: "break-word",
                                              }}
                                            >
                                              {file.original_name ||
                                                file.name ||
                                                `Document ${index + 1}`}
                                            </p>
                                          </a>
                                        ),
                                      )}
                                    </>
                                  )}
                                </div>
                              ) : (
                                <div className="text-center">
                                  {Array.isArray(formData[field.field_id]) &&
                                  formData[field.field_id].length > 0 ? (
                                    <div className="mb-2">
                                      <i
                                        className="bi bi-file-earmark-pdf-fill text-danger"
                                        style={{ fontSize: "50px" }}
                                      />

                                      {formData[field.field_id].map(
                                        (file: any, index: number) => (
                                          <p
                                            key={index}
                                            className="text-danger small mb-0"
                                            style={{
                                              cursor: "pointer",
                                              wordBreak: "break-word",
                                            }}
                                          >
                                            {file?.name ||
                                              file?.original_name ||
                                              "Unknown File"}
                                          </p>
                                        ),
                                      )}
                                    </div>
                                  ) : formData[field.field_id] ? (
                                    <>
                                      <i
                                        className="bi bi-file-earmark-pdf-fill text-danger"
                                        style={{ fontSize: "50px" }}
                                      />

                                      <p
                                        className="text-danger small mb-0"
                                        style={{
                                          cursor: "pointer",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {formData[field.field_id]?.name ||
                                          formData[field.field_id]
                                            ?.original_name}
                                      </p>
                                    </>
                                  ) : field.uploaded_files?.length > 0 ? (
                                    field.uploaded_files.map(
                                      (file: any, index: number) => (
                                        <div key={index} className="mb-2">
                                          <i
                                            className="bi bi-file-earmark-pdf-fill text-danger"
                                            style={{ fontSize: "50px" }}
                                          />

                                          <p
                                            className="text-danger small mb-0"
                                            style={{
                                              cursor: "pointer",
                                              wordBreak: "break-word",
                                            }}
                                          >
                                            {file?.original_name ||
                                              file?.name ||
                                              "Unknown File"}
                                          </p>
                                        </div>
                                      ),
                                    )
                                  ) : (
                                    <>
                                      <i
                                        className="bi bi-file-earmark-pdf-fill text-danger"
                                        style={{ fontSize: "50px" }}
                                      />

                                      <p className="text-muted small mb-0">
                                        No File Selected
                                      </p>
                                    </>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                    </div>

                    {disabledStatuses.includes(templateStatus ?? "") ||
                    templateStatus === "CANDIDATE_INSUFF" ? null : (
                      <div className="d-flex gap-2 align-item-center mt-5">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleSaveDocument}
                          disabled={templateSaveAPI.loading}
                        >
                          {templateSaveAPI.loading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Saving...
                            </>
                          ) : (
                            <>
                              <i className="ti ti-device-floppy me-2"></i>
                              Save
                            </>
                          )}
                        </button>
                      </div>
                    )}
                    {templateStatus === "CANDIDATE_INSUFF" && (
                      <div className="d-flex gap-2 align-items-center mt-5">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleUpdateDocument}
                        >
                          <i className="ti ti-upload me-2"></i>
                          Save Form & Documents
                        </button>

                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={() => setShowReplyModal(true)}
                        >
                          <i className="ti ti-message-circle me-2"></i>
                          Reply to Insufficiency
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="col-md-4">
              <div
                style={{
                  position: "sticky",
                  top: "60px",
                  alignSelf: "flex-start",
                }}
              >
                <div className="card border-0 shadow-sm">
                  {/* Header */}
                  <div
                    className="text-center py-4"
                    style={{ backgroundColor: "#f7f1e3" }}
                  >
                    <div
                      className="d-flex align-items-center justify-content-center mx-auto mb-2 rounded-circle bg-white"
                      style={{ width: "70px", height: "70px" }}
                    >
                      <img src={bulbImage} alt="buld" />
                    </div>

                    <h6 className="fw-bold mb-0">Instructions</h6>
                  </div>

                  {/* Body */}
                  <div className="card-body">
                    {/* Instruction 1 */}
                    <div className="d-flex mb-4">
                      <div
                        className="rounded me-3 mt-1 flex-shrink-0"
                        style={{
                          width: "16px",
                          height: "16px",
                          backgroundColor: "#f4c542",
                        }}
                      ></div>

                      <div>
                        <h6 className="mb-1 fw-semibold">Instruction 1</h6>

                        <p className="text-muted mb-0">
                          Please provide your relevant employment details as
                          mentioned on your official document (Experience
                          Letter, Relieving Letter, Offer Letter) in the form.
                          Please start with your previous employer prior to
                          joining (Teleperformance Global Services Private
                          Limited).{" "}
                        </p>
                      </div>
                    </div>

                    {/* Instruction 2 */}
                    <div className="d-flex mb-4">
                      <div
                        className="rounded me-3 mt-1 flex-shrink-0"
                        style={{
                          width: "16px",
                          height: "16px",
                          backgroundColor: "#f4c542",
                        }}
                      ></div>
                      <div>
                        <h6 className="mb-1 fw-semibold">Instruction 2</h6>

                        <p className="text-muted mb-0">
                          You may be required to attach a copy of the Employment
                          Documents (Appointment Letter, Relieving Letter,
                          Experience Letter). Kindly ensure the
                          photocopy/picture is readable, and is not
                          cut/pixelated/blurred. The required document set will
                          be displayed in the upload documents sections.
                        </p>
                      </div>
                    </div>
                    {/* Instruction 2 */}
                    <div className="d-flex mb-4">
                      <div
                        className="rounded me-3 mt-1 flex-shrink-0"
                        style={{
                          width: "16px",
                          height: "16px",
                          backgroundColor: "#f4c542",
                        }}
                      ></div>
                      <div>
                        <h6 className="mb-1 fw-semibold">Instruction 3</h6>

                        <p className="text-muted mb-0">
                          Note: We will reach out to you immediate/previous
                          employer, once you leave the company and provide us
                          the relevant documentation to proceed ahead with the
                          verification.
                        </p>
                      </div>
                    </div>
                    {/* Instruction 2 */}
                    <div className="d-flex mb-4">
                      <div
                        className="rounded me-3 mt-1 flex-shrink-0"
                        style={{
                          width: "16px",
                          height: "16px",
                          backgroundColor: "#f4c542",
                        }}
                      ></div>
                      <div>
                        <h6 className="mb-1 fw-semibold">Instruction 4</h6>

                        <p className="text-muted mb-0">
                          In case we are unable to obtain verification from your
                          HR/Supervisor due to non-responsiveness, we can
                          utilise the data from your Form 16 to validate your
                          employment .{" "}
                        </p>
                      </div>
                    </div>
                    <div className="d-flex mb-4">
                      <div
                        className="rounded me-3 mt-1 flex-shrink-0"
                        style={{
                          width: "16px",
                          height: "16px",
                          backgroundColor: "#f4c542",
                        }}
                      ></div>
                      <div>
                        <h6 className="mb-1 fw-semibold">Instruction 5</h6>

                        <p className="text-muted mb-0">
                          It is recommended to provide form 16 for any
                          assessment year pertaining to the employer’s
                          details.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showReplyModal && (
            <div
              className="modal fade show d-block"
              style={{ background: "rgba(0,0,0,.5)" }}
            >
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content border-0 shadow">
                  {/* Header */}
                  <div className="modal-header">
                    <div>
                      <h5 className="modal-title fw-bold mb-1">
                        Respond to Insufficiency
                      </h5>

                      <small className="text-muted">
                        Please provide your explanation and upload supporting
                        documents if applicable.
                      </small>
                    </div>

                    <button
                      className="btn-close"
                      onClick={() => setShowReplyModal(false)}
                    />
                  </div>

                  {/* Body */}
                  <div className="modal-body">
                    {/* Remarks */}
                    <div className="mb-4">
                      <label className="form-label fw-semibold">
                        Remarks
                        <span className="text-danger ms-1">*</span>
                      </label>

                      <textarea
                        rows={5}
                        className="form-control"
                        placeholder="Enter your response to the verifier..."
                        value={replyRemarks}
                        onChange={(e) => setReplyRemarks(e.target.value)}
                        style={{ resize: "none" }}
                      />

                      <small className="text-muted">
                        Clearly explain the requested information or
                        clarification.
                      </small>
                    </div>

                    {/* Upload */}
                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        Supporting Documents
                      </label>

                      <input
                        type="file"
                        className="form-control"
                        multiple
                        accept=".jpg,.jpeg,.png,.pdf"
                        onChange={handleReplyFileChange}
                      />

                      <small className="text-muted">
                        Accepted formats: JPG, JPEG, PNG, PDF (Maximum 10 MB per
                        file)
                      </small>
                    </div>

                    {/* Selected Files */}
                    {replyDocuments.length > 0 && (
                      <div className="mt-3">
                        <label className="fw-semibold mb-2">
                          Selected Files
                        </label>

                        <div className="d-flex flex-wrap gap-2">
                          {replyDocuments.map((file, index) => (
                            <span
                              key={index}
                              className="badge rounded-pill bg-success-subtle text-dark border border-success-subtle px-3 py-2 d-flex align-items-center"
                            >
                              <i className="ti ti-paperclip me-2"></i>

                              <span
                                className="text-truncate"
                                style={{ maxWidth: 180 }}
                              >
                                {file.name}
                              </span>

                              <button
                                type="button"
                                className="btn btn-sm border-0 bg-transparent text-danger ms-2 p-0"
                                onClick={() => removeReplyFile(index)}
                              >
                                <i className="ti ti-x"></i>
                              </button>
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Footer */}
                  <div className="modal-footer gap-3">
                    <button
                      className="btn btn-light border"
                      onClick={() => setShowReplyModal(false)}
                    >
                      Cancel
                    </button>

                    <button
                      className="btn btn-primary"
                      onClick={handleSubmitReply}
                      disabled={insuffResponse.loading}
                    >
                      {insuffResponse.loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Submitting...
                        </>
                      ) : (
                        <>
                          <i className="ti ti-send me-2"></i>
                          Submit Response
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <Footer />
      </div>
    </>
  );
};

export default EmployementForm1;
